import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
import { pushNotifications } from './Config';
import InitialState from '@/InitialState';

let firebaseApp = null;
let messaging = null;

export function initFirebase() {
    if (!firebaseApp && InitialState.featureFlags.pushNotificationsEnabled) {
        firebaseApp = initializeApp({
            apiKey: pushNotifications.apiKey,
            authDomain: pushNotifications.authDomain,
            projectId: pushNotifications.projectID,
            storageBucket: pushNotifications.storageBucket,
            messagingSenderId: pushNotifications.messagingSenderID,
            appId: pushNotifications.appID,
        });
    }
}

export function initFirebasePush() {
    if (!InitialState.featureFlags.pushNotificationsEnabled) return null;

    if (!messaging) {
        messaging = getMessaging(firebaseApp);
    }

    return messaging;
}